/**
 * @module app.cs
 */

import { autoinject, transient } from 'aurelia-framework';
import { Api } from 'app/shared/lib/api/api';
import { IApiQueryResults, IQueryLoadOptions } from 'app/shared/lib/api/api-types';
import { AppLogger } from 'app/shared/lib/logging/app-logger';
import * as CS from 'app/cs/models/essette-api';

/**  Provides access to API models related to CS Issues */
@transient()
@autoinject()
export class IssueService {

    ////****************** Fields and Properties ************************************////


    ////****************** Functions ************************************************////
    constructor(
        private readonly api: Api,
        private readonly logger: AppLogger) {

        this.logger.source = this;
    }

    ////****************** Settings *************************************************////


    ////****************** Queries **************************************************////


    ////****************** Loads ****************************************************////
    public async loadIssuesByMember(memberId: string, options?: Partial<IQueryLoadOptions>, includes: string[] = [], fields: string[] = []): Promise<IApiQueryResults<CS.MemberIssue>> {
        const query = this.api
            .query('cs/members/issues/')
            .filterIdentifier('member.id', memberId)
            .applyStandardLoadOptions(options)
            .include(...includes)
            .field(...fields);

        return await this.api.get(query);
    }

    public async loadIssueByDetail(detailProperty: string, detailId: string, includes: string[] = []): Promise<IApiQueryResults<CS.MemberIssue>> {
        const query = this.api
            .query('cs/members/issues/')
            .filterExists(detailProperty, q => q.filterIdentifier('id', detailId))
            .include(...includes)
            .top(1);

        return await this.api.get(query);
    }

    ////****************** Actions **************************************************////

}
